query GetContractSummary {
  contractSummary {
    deadlinesWithin30Days
    deadlinesWithin31To90Days
    ownerLeft
    drafts
    liveByEntity {
      legalEntity {
        id
        name
      }
      count
    }
  }
}
